'use client'
import { useTranslations } from 'next-intl'
import WithQueryParams from '@/hoc/withQueryParams'
import { useUser } from '@auth0/nextjs-auth0'

import { PERSONAL_AREA_NAME } from '@/config/constants'

import { Link } from '@/i18n/navigation'

import Button from '@/components/atoms/Button'
import { ButtonLabel } from '@/components/atoms/Typography'
import Icon from '@/components/atoms/Icon'

const AccessLink = ({ href = `/${PERSONAL_AREA_NAME}` }: { href: string }) => {
  const { user, isLoading } = useUser()
  const t = useTranslations('General')
  const userLogged = !!user && !isLoading

  return (
    !userLogged && (
      <Button
        as={Link}
        href={href}
        autoWidth
        theme='dark'
        iconPosition='right'
        Icon={() => <Icon iconName='UserCircle' />}
      >
        <ButtonLabel>{t('access')}</ButtonLabel>
      </Button>
    )
  )
}

export default WithQueryParams(AccessLink)
